<div class="apply-one-grid apply-one-style">
  <div class="site-width">
    <div class="container-fluid py-1">
      <ecm-mat-feedback
        [style]="'warning'"
        [title]="error.title"
        [text]="error.description"
        [confirmationStyle]="linkStyle"
        [confirmationLabel]="redirectLabel"
        (materialFeedbackConfirm)="redirectionLink()"
      >
      </ecm-mat-feedback>
    </div>
  </div>
</div>
